import localImg from '../../assets/resources/blog/no-image-icon.png';
import localVideo from '../../assets/resources/blog/video-icon.jpg';

const today = new Date();

export const CLOUD_BLOG_COVER = '1hSrUHFV-PUYj4WMVYc8KFb-jffB_UpNL';

// ReactQuill constants
export const modules = {
    toolbar: {
        container: "#toolbar",
    }
};
export const modulesQuill = {
    toolbar: {
        container: "#mytoolbar",
    }
};
export const formats = [
    'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'header', 'blockquote', 'code-block',
    'indent', 'list',
    'direction', 'align',
    'link', 'image', 'video', 'formula',
];
const colors = ["red", "green", "blue", "orange", "violet", "brown"];
export const quillFormats = [
    [
        {
            className: "ql-font",
            options: ['serif', 'monospace']
        },
        {
            className: "ql-size",
            options: ["small", "large", "huge"]
        }
    ],
    [
        { className: "ql-bold" }, { className: "ql-italic" }, { className: "ql-underline" }, { className: "ql-strike" }
    ],
    [
        {
            className: "ql-color",
            options: colors
        },
        {
            className: "ql-background",
            options: colors
        }
    ],
    [
        {
            className: "ql-script",
            value: "sub"
        },
        {
            className: "ql-script",
            value: "super"
        }
    ],
    [
        {
            className: "ql-header",
            value: "1"
        },
        {
            className: "ql-header",
            value: "2"
        },
        {
            className: "ql-blockquote"
        },
        {
            className: "ql-code-block"
        }
    ],
    [
        {
            className: "ql-list",
            value: "ordered"
        },
        {
            className: "ql-list",
            value: "bullet"
        },
        {
            className: "ql-indent",
            value: "-1"
        },
        {
            className: "ql-indent",
            value: "+1"
        }
    ],
    [
        {
            className: 'ql-direction',
            value: 'rtl'
        },
        {
            className: 'ql-align',
            options: ['right', 'center', 'justify']
        }
    ],
    [
        { className: 'ql-link' }, { className: 'ql-image' }, { className: 'ql-video' }, { className: 'ql-formula' }
    ]
];

// valores iniciales blog
export const BLOG_INIT = {
    title: '',
    author: '',
    publication_date: today
};

export const BLOG_VIEW = {
    title: '',
    url: '',
    author: '',
    publication_date: '',
    category: [],
    imgId: CLOUD_BLOG_COVER,
    content: [],
    preview: ''
};

export const BLOG_ROW_DEFAULT = [
    {
        col: [], // arreglo de bloques
        id: 'row-0'
    },
    {
        col: [], // contiene objetos del tipo BLOCK_EDITION
        id: 'row-1'
    }
];

// formato de bloque en edición
export const BLOCK_EDITION = {
    item: '',
    src: '',
    file: '',
    type: 'txt',
    xs: 12,
    md: 12,
    id: 'col-0', // ID de columna
    row_index: 'row-0' // index de fila
};

// contenido de blog en edición
export const BLOG_EDITION = {
    _id: '',
    title: '',
    author: '',
    publication_date: today,
    category: [],
    folderId: '',
    imgId: CLOUD_BLOG_COVER,
    imgUploaded: false,
    content: [{
        col: [],
        id: 'row-0'
    }]
};

// portada por defecto de blog
export const DEFAULT_BLOG_COVER = {
    imgSrc: localImg,
    imgFile: ''
};

// portada por defecto de blog (actualización)
export const DEFAULT_BLOG_COVER_UPD = {
    imgSrc: localImg,
    imgFile: '',
    imgUploaded: false
};

// portada de video en contenido de blog
export const BLOG_VIDEO_COVER = localVideo;